<script lang="ts" setup>
import { AppTypography } from '@/components/base';

const { group = 'templating', iconClass = '!text-6xl' } = defineProps<{
  group?: string;
  /** Tailwind/CSS classes applied to the confirm dialog icon. Defaults to `!text-6xl`. */
  iconClass?: string;
}>();
</script>

<template>
  <ConfirmDialog :group="group" :draggable="false">
    <template #message="slotProps">
      <div class="flex w-full flex-col items-center gap-4">
        <i
          v-if="!!slotProps.message.icon"
          :class="[slotProps.message.icon, iconClass]"
        />
        <AppTypography type="body">{{
          slotProps.message.message
        }}</AppTypography>
      </div>
    </template>
  </ConfirmDialog>
</template>

<style lang="scss" scoped></style>
